import React from 'react'
import styled from 'styled-components'
import { ListRowWrapper, Heading3 } from '../../components/layout'
import { messages } from './messages'
import { formatMessageSafe } from '../../util/translateInputOptions'
import { useIntl } from 'react-intl'

const NoTowingJobsIntl: React.FunctionComponent = () => {
  const intl = useIntl()
  const formatMessage = formatMessageSafe(intl)

  return (
    <ListRowWrapper>
      <EmptyContainer>
        <Heading3>{formatMessage(messages.noTowingJobs)}</Heading3>
      </EmptyContainer>
    </ListRowWrapper>
  )
}

const EmptyContainer = styled.div`
  text-align: center;
  padding: 2rem;
`

export const NoTowingJobs = NoTowingJobsIntl
